<template>
  <div class="card-new">
    <div class="card-header">
      <div class="flex flex-row">
        <div
            :class="current === 'container' ? 'text-primary bg-white' : 'text-gray-500 bg-slate-200 hover:bg-slate-100 cursor-pointer'"
            @click.prevent="switchView('container')" class="py-3 text-primary rounded-tl-xl text-center w-1/2">
          Container Vessels
        </div>
        <div
            :class="current === 'general' ? 'text-primary bg-white' : 'text-gray-500 bg-slate-200 hover:bg-slate-100 cursor-pointer'"
            @click.prevent="switchView('general')" class="py-3 text-primary rounded-tr-xl text-center w-1/2">
          General Cargo
        </div>
      </div>
    </div>
    <div class="card-content">
      <div v-if="loading" class="w-full animate-pulse bg-slate-200 h-20 rounded-sm p-4">
        <div class="flex justify-between">
          <div class="h-5 w-2/4 rounded-sm bg-slate-300 animate-pulse">
          </div>
          <div class="h-5 w-1/4 rounded-sm bg-slate-300 animate-pulse">
          </div>
        </div>
        <div class="text-center mt-2">
          <i class="fad fa-spinner fa-spin opacity-50"></i>
        </div>
      </div>

      <p class="text-center text-slate-400" v-if="!container_count && !loading && current === 'container'">No Container
        Vessels Currently in Operation</p>

      <p class="text-center text-slate-400" v-if="!general_count && !loading && current === 'general'">No General Cargo
        Vessels in Operation</p>

      <div class="flex flex-col divide-y divide-slate-100">
        <div
            v-for="item in viewResults"
            v-bind:key="item.pos"
            class="ship-card hover:bg-slate-100 cursor-pointer py-2 px-3"
        >
          <div class="flex flex-col">
            <div class="flex flex-wrap">
              <div class="w-full flex flex-row justify-between md:items-center mb-3">
                <div class="  flex-wrap">
                  <div class="w-full text-base text-gray-800 font-medium">
                    {{ item.vessel_name }}
                    <br class="block md:hidden">
                    <span class="text-xs ml-0 md:ml-2 font-normal text-gray-600"
                    >Arrived on: {{ item.arrival_date }}</span
                    >
                    <br/>
                  </div>
                </div>
                <div class="text-right">
                  <span v-if="item.Total_Units != 0" v-bind:class="getStatusColor(item.current_status.status)"
                        class=" text-xs uppercase font-medium">{{ item.current_status.status }}</span>
                </div>
              </div>
              <div class="w-2/3">
                <span class="text-blue-800">BL
                  <span v-if="item.BL_Status === 'Submitted'">{{ item.BL_Status }} </span>
                  <span v-if="item.BL_Status != 'Submitted'">{{ item.BL_Status }} by Agent </span>

                  <i
                      v-if="item.BL_Status === 'Submitted'"
                      class="fad text-green-600 fa-check-circle"
                  ></i>

                  <i
                      v-if="item.BL_Status != 'Submitted'"
                      class="fad text-orange-600 fa-exclamation-circle"
                  ></i>
                </span>
              </div>
              <div v-if="item.Total_Units" class="w-1/3 text-right">
                <span class="text-blue-800 whitespace-nowrap">{{ item.Unloaded }}/{{ item.Total_Units }} Unloaded</span>
              </div>
            </div>

            <p v-if="item.current_status.status === 'Operation stopped' " style="font-size: .8em;">
              {{ item.current_status.reason }}</p>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {Component, Vue} from "vue-property-decorator";
import BandharuService from "@/services/bandharu.service";


@Component({
  components: {},
})
export default class ShipsAtPort extends Vue {
  private service = new BandharuService();

  private result = [];
  private viewResults = [];
  private current = 'container';
  private container_count = 0;
  private general_count = 0;

  mounted() {
    this.getShipsAtPort();
  }

  getShipsAtPort() {
    this.loading = true;
    this.service
        .getShipsAtPort()
        .then((res) => {
          // console.log(res.data);
          this.result = res;
          this.switchView(this.current);
          this.loading = false;
          this.checkEmpty();
        })
        .catch((error) => {
          console.log("Error fetching ships at port");
          this.loading = false;
        });
  }

  switchView(page: any) {
    this.current = page;
    this.viewResults = this.result.filter((item: any) => {
      if (page === 'container') {
        return item.Total_Units !== 0;
      } else {
        return item.Total_Units === 0;
      }
    });
  }

  checkEmpty() {
    this.result.map((res: any) => {
      if (res.Total_Units === 0) {
        this.general_count = this.general_count + 1;
      } else {
        this.container_count = this.container_count + 1;
      }
    });
  }

  getStatusColor(data: any) {
    if (data === 'Idle') {
      return 'text-blue-500'
    } else if (data === 'Operation completed') {
      return 'text-green-700'
    } else if (data === 'Operation ongoing') {
      return 'text-green-600'
    } else if (data === 'Operation stopped') {
      return 'text-red-500'
    } else if (data === 'Operation not started') {
      return 'text-gray-800'
    }
  }

  private loading = false;
}
</script>
